<template>
  <!-- 休日出勤申請一覧 -->
  <div id="monthlyreport">
    <CCard>
      <CCardHeader><h2>休日出勤申請一覧</h2></CCardHeader>
      <CCardBody>
          <table class="table search-table">
            <tr>
            <th style="width: 100px">年月</th>
            <th style="width: 75px"></th>
            <th style="width: 50px"></th>
              <th colspan="2"></th>
            </tr>
            <tr>
              <td>
                <select
                  class="custom-select"
                  v-model="year"
                  style="width: 90px"
                >
                  <option
                    v-for="option in yearOption"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </td>
              <td>
                <select
                  class="custom-select"
                  v-model="month"
                  style="width: 70px"
                >
                  <option
                    v-for="option in monthOption"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </td>
              <td>業務分</td>              
              <td>
                <button class="btn btn-primary" @click="callList">検索</button>
              </td>
            </tr>
          </table>
      </CCardBody>
      <template v-if="callFlg">
        <!-- <CCardHeader><strong>詳細入力</strong></CCardHeader> -->
        <CCardBody>
                  <div class="table-responsive">
            <table class="table table-bordered">
            <thead>
              <tr>
                  <th scope="col" width="100px">社員名</th>
                <th scope="col" width="40px">日付</th>
                <th scope="col">予定時刻</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items" :key="index">
                <td>
                  <router-link
                    :to="{
                      name: holidayWorksMsterInfo,
                      params: { id: item.id },
                    }"
                    >{{ item.user_name }}</router-link
                  >
                </td>
                <td>{{ formatDate(item.date) }}</td>
                <td>
                  {{ formatTime(item.start_time)
                  }}<block v-if="item.end_time">～</block
                  >{{ formatTime(item.end_time) }}
                </td>
              </tr>
            </tbody>
          </table>
                  </div>
          <div class="d-flex justify-content-center">
            <!-- ページング処理 -->
            <VPagination
              v-model="currentPage"
              :click-handler="changePage"
              :page-count="totalPages"
              :force-ellipses="true"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :prev-text="'<'"
              :next-text="'>'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
              :page-link-class="'page-link'"
              :class-prefix="'pagination'"
            />
          </div>
        </CCardBody>
      </template>
    </CCard>
  </div>
</template>
  
  <script>
import ConstList from "../../ConstList";
import axios from "axios";
import moment from "moment";
import VPagination from "vuejs-paginate";
export default {
  name: "MonthlyReport",
  components: {
    VPagination,
  },
  data() {
    return {
      year: "",
      month: "",
      date: "",
      items: [],
      callFlg: false,
      type_options: [ConstList.ALLDAY, ConstList.MORNING, ConstList.AFTERNOON],
      holidayWorksMsterInfo: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
    };
  },
  created() {
    this.yearOption = ConstList.YEAR_OPTION;
    this.monthOption = ConstList.MONTH_OPTION;
    this.holidayWorksMsterInfo = ConstList.ROUTE_HOLIDAYWORKS_MASTERINFO;
  },

  methods: {
    formatTime(timeString) {
      if (!timeString) return "";

      // 時間文字列をパースして、時間と分を抽出
      const [hours, minutes] = timeString.split(":");
      return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
    },
    callList: function () {
      this.callFlg = false;
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      this.fetchTotalPages();
      params.append("currentPage", this.currentPage);
      params.append("pageSize", this.pageSize);
      params.append("totalPages", this.totalPages);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/holidaywork", {
          params: {
            year: this.year,
            month: this.month,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then((response) => {
          this.items = response.data;
          this.callFlg = true;
          // sessionStorageへ保存
          sessionStorage.setItem(
            "holidayworkList-search-items",
            JSON.stringify(this.items)
          );
          sessionStorage.setItem(
            "holidayworkList-search-params",
            JSON.stringify({
              year: this.year,
              month: this.month,
              currentPage: this.currentPage,
              pageSize: this.pageSize,
              totalPages: this.totalPages,
            })
          );
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },
    // 承認状態の識別
    statusColor(status) {
      switch (status) {
        case ConstList.REJECT:
        case ConstList.UNSUBMITTED: 
          return { color: 'red' };
        case ConstList.APPROVAL_PENDING:
          return { color: 'orange' };
        case ConstList.APPROVAL:
          return { color: 'green' };
        default:
          return {};
      }
    },
    // ページ変更
    changePage: function (page) {
      this.currentPage = page;
      this.callList();
    },
    // アイテム数とページサイズに基づいて合計ページ数を計算
    fetchTotalPages: function () {
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/holidaywork/count", {
          params: {
            year: this.year,
            month: this.month,
          },
        })
        .then((response) => {
          const totalCount = response.data;
          this.totalPages = Math.ceil(totalCount / this.pageSize);
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },
    // yyyy/mm/ddフォーマット変換
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
  },
  mounted: function () {
    // 前回の検索パラメータがあれば取得
    if (
      Object.prototype.hasOwnProperty.call(
        sessionStorage,
        "holidayworkList-search-items"
      )
    ) {
      //this.callFlg = true;
      //this.items = JSON.parse(
      //  sessionStorage.getItem("holidayworkList-search-items")
      //);
      const params = JSON.parse(
        sessionStorage.getItem("holidayworkList-search-params")
      );
      this.year = params.year;
      this.month = params.month;
      this.callList();
      this.callFlg = true;
      //this.currentPage = params.currentPage;
      //this.pageSize = params.pageSize;
      //this.totalPages = params.totalPages;
    } else {
      const today = moment().subtract(1, 'months');
      this.year = today.format("YYYY");
      this.month = today.format("M");
    }
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  
  <style scoped>
th,
td {
  white-space: nowrap;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
  